import React, { useState, useEffect, useRef } from 'react';
import Input from '@mui/material/TextField';

export type CouponInputProps = {
  fields: number;
  onChange: (arg: string) => void;
  onPaste?: (arg: React.ClipboardEvent) => void;
  text?: string;
}

const CouponInput: React.FC<CouponInputProps> = ({
  fields, onChange, onPaste, text,
}: CouponInputProps) => {
  const refInputs = useRef<HTMLInputElement[]>([]);
  const a = [...Array(fields).keys()];
  const [input, setInput] = useState<string[]>(a.map(() => ''));
  const [currentFocus, setCurrentFocus] = useState<number>(-1);

  useEffect(() => {
    if (currentFocus < a.length && currentFocus >= 0) {
      refInputs.current[currentFocus].focus();
    }
  }, [currentFocus, a.length]);

  useEffect(() => {
    onChange(input.join(''));
  }, [input, onChange]);

  useEffect(() => {
    if (text?.trim() && text.trim().length > 0) {
      setInput(text.split(''));
    }
  }, [text]);

  const handleInput = (
    e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement>, id: number,
  ): void => {
    const { value } = e.target;
    if (value.length > 1 || !/\w+|^$/.test(value)) {
      return;
    }
    const newInput = [...input];
    newInput[id] = e.target.value;
    setInput(newInput);
    if (/\w+/.test(value)) {
      setCurrentFocus(id + 1);
    }
    if (value === '') {
      setCurrentFocus(id - 1);
    }
  };

  return (
    <>
      {
        a.map((i: number) => (
          <Input
            onPaste={onPaste}
            onClick={(): void => { setCurrentFocus(i); }}
            key={i}
            onChange={(e): void => { handleInput(e, i); }}
            sx={{ width: 40, mx: '5px' }}
            variant="outlined"
            value={input[i]}
            inputRef={(el): void => { refInputs.current[i] = el as HTMLInputElement; }}
          />
        ))
      }
    </>
  );
};

export default CouponInput;
